import React, { Component, Fragment } from 'react';

export default class extends Component<Props, void> {
  static _type = 'Fragment';
  _type = 'Fragment';

  render() {
    const { children } = this.props;
    return (
      <Fragment>
        {children}
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/fitbit-components/fragment.js